module.exports = __webpack_public_path__ + "static/media/masdar-logo-blue.20bf0d66.svg";